export default __webpack_public_path__ + "static/media/Coin.7e94435a.png";